export default "__VITE_ASSET__D38_LKNX__"